import { render, staticRenderFns } from "./Phonebook.vue?vue&type=template&id=7821c3b1&scoped=true"
import script from "./Phonebook.vue?vue&type=script&lang=js"
export * from "./Phonebook.vue?vue&type=script&lang=js"
import style0 from "./Phonebook.vue?vue&type=style&index=0&id=7821c3b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821c3b1",
  null
  
)

export default component.exports